import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
import vuexStorage from '../store/index.js'
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
  new Vue().$notify({
      title: title,
      message: content,
      type: 'error',
      position: 'bottom-right'
  })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction d'activation de template
async function activerTemplate(id, active) {
  if (id != null) {
    active = active ? 0 : 1;
    try {
      await requestApi({
        method: 'POST',
        url: '/api/activeTemplate',
        form: { id, active },
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      for (let i = 0; i < this.templates.length; i++) {
        if (this.templates[i].value == id) {
          this.templates[i].active = active;
        }
      }
    } catch (error) {
      if (error.response !== undefined) {
        toasterError('Activation de template impossible', 'Activation de template');
        if (error.response.data.route != null) {
          this.$router.push(error.response.data.route);
        }
      } else {
        toasterError('Le service est momentanément indisponible', 'Service indisponible');
      }
    }
  } else {
    toasterError('Le template ne peut être activé', 'Activation de template');
  }
}

//Fonction qui permet d'ajouter la class active au menu profil du client
function activeClassMenuProfil() {
  const url = window.location.pathname;
  const classActive = document.getElementById("navigation");
  for (let i = 0; i < classActive.children.length; i++) {
    const link = classActive.children[i].children[0];
    link.classList.remove("active", "router-link-exact-active", "router-link-active");
    const path = link.getAttribute("href");
    if (path === url) {
      link.classList.add("active", "router-link-exact-active", "router-link-active");
    }
  }
}

//Fonction d'ajout de produit à un devis
async function addProduct(item) {
  if (this.selectedTypeLine == 2) {
    let found = false;
    for (let i = 0; i < this.products.length; i++) {
      if (item.id == this.products[i].id) {
        this.products[i].qty = parseInt(item.qty) + parseInt(this.products[i].qty);
        this.products[i].totalHt = Number.parseFloat(this.products[i].qty * item.prixUnitaire).toFixed(2);
        found = true;
      }
    }
    if (!found) {
      this.products.push({
        id: item.id,
        ref: item.ref,
        label: item.label,
        description: item.description,
        tva: Number.parseFloat(item.tva).toFixed(2),
        prixUnitaire: item.prixUnitaire,
        qty: item.qty,
        reduction: item.reduction,
        totalHt: Number.parseFloat(item.qty * item.prixUnitaire).toFixed(2),
        productType: item.type,
        start: this.limitedService.start,
        finish: this.limitedService.finish
      });
    }
  } else {
    if (this.selectedProductType == 1) {
      if (this.limitedService.start > this.limitedService.finish) {
        this.$bvToast.toast(`La date début doit être supérieure à la date de fin du service`, {
          title: 'Service à durée limitée',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        });
      } else {
        this.products.push({
          id: item.id,
          label: item.label,
          tva: Number.parseFloat(item.tva).toFixed(2),
          prixUnitaire: item.prixUnitaire,
          qty: item.qty,
          reduction: item.reduction,
          totalHt: Number.parseFloat(item.qty * item.prixUnitaire).toFixed(2),
          productType: this.selectedProductType,
          start: this.limitedService.start,
          finish: this.limitedService.finish
        });
      }
    } else {
      this.products.push({
        id: item.id,
        label: item.label,
        tva: Number.parseFloat(item.tva).toFixed(2),
        prixUnitaire: item.prixUnitaire,
        qty: item.qty,
        reduction: item.reduction,
        totalHt: Number.parseFloat(item.qty * item.prixUnitaire).toFixed(2),
        productType: this.selectedProductType
      });
    }
  }
  this.deleteProduct();
}

//Fonction de modification des infos perso du client
async function changeInfoPerso(infoClients, infoPerso) {
  const keys = Object.keys(infoPerso);
  const changeInfo = [];
  let j = 0;
  for (let i = 0; i < keys.length; i++) {
    if (infoClients[keys[i]] != infoPerso[keys[i]] && keys[i] != "array_options") {
      changeInfo[j] = [keys[i], infoPerso[keys[i]]];
      j++;
    }
  }

  if (changeInfo.length > 0) {
    try {
      const response = await requestApi({
        method: 'POST',
        url: '/api/changeInfoPerso',
        form: changeInfo,
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      alert(response);
    } catch (error) {
      if (error.response !== undefined) {
        this.$bvToast.toast(`Changement d'information impossible`, {
          title: 'Changement d\'informations',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        });
        if (error.response.data.route != null) {
          this.$router.push(error.response.data.route);
        }
      } else {
        toasterError('Le service est momentanément indisponible', 'Service indisponible');
      }
    }
  }
}

//Fonction envoi mail changement de mot de passe
async function changePassOublie() {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/createToken',
      form: { email: this.loginOublie },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$bvToast.toast(`Un lien vient de vous être envoyé dans votre boîte mail`, {
      title: 'Changement de mot de passe',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
    this.$router.push("../login");
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Changement de mot de passe impossible`, 'Changement de mot de passe');
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      this.$router.push("../login");
    }
  }
}

//Fonction de changement de mot de passe
async function changePassword(form) {
  if (form.newPwd == form.newPwd2) {
    try {
      await requestApi({
        method: 'POST',
        url: '/api/changePassword',
        form: form,
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      alert("Votre mot de passe à été changé vous allez être redirigé vers la page de login");
      try {
        const response = await requestApi({
          method: 'POST',
          url: '/api/disconnect',
          form: {},
          params: {},
          headers: { 'Content-Type': 'application/json' }
        });
        this.$router.push(response.route);
      } catch {
        this.$router.push('/');
      }
    } catch (error) {
      if (error.response !== undefined) {
        toasterError(error.response, 'Changement de mot de passe');
      } else {
        toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      }
    }
  } else {
    toasterError(`Les mots de passe ne correspondent pas`, 'Changement de mot de passe');
  }
}

//Changement de la vitesse du carrousel
async function changeSpeed() {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/changeConfCarrousel',
      form: { vitesse: this.confCarrousel.vitesse },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    alert("Vitesse du carrousel changée");
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Changement de vitesse du carrousel impossible`, 'Changement de vitesse');
      if (error.response.data.route != null) {
        this.$router.push(error.response.data.route);
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de choix de produit
async function chooseProduct(item) {
  try {
    const resProduct = await requestApi({
      method: 'GET',
      url: '/api/getProduct/' + item.value,
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.product[0].id = resProduct.id;
    this.product[0].ref = resProduct.ref;
    this.product[0].description = resProduct.description;
    this.product[0].label = resProduct.label;
    this.product[0].tva = resProduct.tva;
    this.product[0].prixUnitaire = Number.parseFloat(resProduct.price).toFixed(2);
    this.product[0].qty = '1';
    this.product[0].reduction = "";
    this.product[0].type = resProduct.type;
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Le produit est inexistant`, 'Recherche de produit');
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de commentaire sur le document client
function commentDoc(){
  //console.log(doc);
}

//fonction de création de propale
async function createPropal() {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/createPropal',
      form: { form: this.form, products: this.products },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$bvToast.toast(`Création de proposition commerciale réussie`, {
      title: 'Création de proposition commerciale',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
    this.$router.push('../login');
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Impossible de créer la proposition commerciale`, 'Création de proposition commerciale');
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Suppression d'une image du carrousel
async function deleteImg(chemin) {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/deleteImg',
      form: { chemin },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    window.location.reload();
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Impossible de supprimer l'image`, 'Suppression d\'image');
      if (error.response.data.route != null) {
        this.$router.push(error.response.data.route);
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de suppression de produit à ajouter
function deleteProduct () {
  this.product[0].id = ''
  this.product[0].ref = ''
  this.product[0].description =  ''
  this.product[0].label =  ''
  this.product[0].tva = '20.000'
  this.product[0].prixUnitaire = ''
  this.product[0].qty = '1'
  this.product[0].reduction = ''
  this.productSearch = ''
  this.limitedService.start = ''
  this.limitedService.finish = ''
}

//Fonction de suppression de produit devis
function deleteProducts (item) {
  this.products.splice(item.index,1)
}

//Fonction de déconnexion
async function disconnect() {
  var disconnected = confirm("Voulez-vous vous déconnecter?");
  if(disconnected == true){
    try {
      await requestApi({method: 'POST', url: '/api/disconnect?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
      this.$router.push('/')
    } catch (error) {
      console.log(error)
      this.$router.push('/')
    }
    // this.axios.post(conf.server+"/api/disconnect",{},{withCredentials:true})
    // .then(() => {
    //   this.$router.push('/');
    // })
    // .catch(() => {
    //   this.$router.push('/');
    // })
  }
}



//Fonction de récupération des infos perso du client
async function getInfoClient() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/getInfoPersoClient',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.infoClients = response;
    this.infoPerso = JSON.parse(JSON.stringify(this.infoClients));
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Impossible de charger les informations client`, 'Chargement des infos');
      if (error.response.data.route != null) {
        this.$router.push(error.response.data.route);
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de récupération des infos de la société du client
async function getInfoSocClient() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/getInfoSocClient',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.infoSocClient = response;
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Impossible de charger les informations de la société`, 'chargement des infos de société');
      if (error.response.data.route != null) {
        this.$router.push(error.response.data.route);
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de génération des infos à envoyer au client  
async function info(row, target) {
  this.form.email = row.email;
  this.modalInfo.title = 'Contact: ' + row.firstname + ' ' + row.lastname;

  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/passwordGenerator',
      form: { email: row.email },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });

    this.pwd = response.pwd;
    this.tokenReinit = response.tokenReinit;
    this.loadingTemplateMail(this.templateSelected, this.form.email, this.pwd, this.tokenReinit);
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }

  this.$root.$emit('bv::show::modal', 'modalInfo', target);
}

//Fonction de vérification de connexion pour la page login
//Si l'utilisateur est connecté il est redirigé vers la page index
async function isConnect() {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/isConnect',
      form: {},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$router.push(response.route);
  } catch {
    this.$router.push('login');
  }
}


//Fonction pour itérer massive contact
async function iterateMassiveContact(user, template) {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/passwordGenerator',
      form: { email: user.email },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    const pwd = response.pwd;
    const tokenReinit = response.tokenReinit;

    const response2 = await requestApi({
      method: 'POST',
      url: '/api/getInfoClient',
      form: { email: user.email },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    const ref = response2.ref_entreprise;
    const nomEntreprise = response2.nom_entreprise;

    const response3 = await requestApi({
      method: 'POST',
      url: '/api/template',
      form: {
        template: template,
        email: user.email,
        pwd: pwd,
        tokenReinit: tokenReinit,
        prenom: user.firstname,
        nom: user.lastname,
        ref: ref,
        nomEntreprise: nomEntreprise
      },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });

    await requestApi({
      method: 'POST',
      url: '/api/createAccess',
      form: {
        email: user.email,
        pwd: pwd,
        tokenReinit: tokenReinit,
        contenuMail: response3
      },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });

    this.$refs.modalAjoutExtranet.hide();
  } catch (error) {
    if (error.response !== undefined) {
      toasterError(`Impossible de créer l'accès à l'extranet`, 'Création d\'accès');
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Chargement des images du carrousel
async function loadCarrousel() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/imagesCarrousel',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    for (var i = 0; i < response.length; i++) {
      var tmp = { chemin_img: response[i].chemin_img };
      this.imgCarrousel.push(tmp);
    }
    this.totalRows = response.length;
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de chargement des documents du client
async function loadDocuments(type) {
  let param;
  if (this.$route.params.id !== undefined) {
    param = {
      type: type,
      id: this.$route.params.id
    };
  } else {
    param = {
      type: type,
      id: 0
    };
  }

  try {
    let documents;
    switch (type) {
      case 'contracts':
        documents = await requestApi({
          method: 'GET',
          url: '/api/getContracts?nocache=' + new Date().getTime(),
          params: param,
          form: {},
          headers: { 'Content-Type': 'application/json' }
        });
        documents.forEach(contract => {
          contract.date_creation = moment(contract.date_creation * 1000).format("DD-MM-YYYY");
          contract.date_signature = moment(contract.array_options.options_ec_signature_date * 1000).format("DD-MM-YYYY");
          contract.date_effective = moment(contract.array_options.options_ec_effective_date * 1000).format("DD-MM-YYYY");
          contract.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: 'EUR' }).format(contract.total_ht);
          contract.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: 'EUR' }).format(contract.total_ttc);
          vuexStorage.commit("addContract", contract);
        });
        break;
      case 'proposals':
        documents = await requestApi({
          method: 'GET',
          url: '/api/getProposals?nocache=' + new Date().getTime(),
          params: param,
          form: {},
          headers: { 'Content-Type': 'application/json' }
        });
        documents.forEach(proposal => {
          proposal.date_creation = moment(proposal.date_creation * 1000).format("DD-MM-YYYY");
          proposal.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: proposal.multicurrency_code }).format(proposal.total_ht);
          proposal.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: proposal.multicurrency_code }).format(proposal.total_ttc);
          vuexStorage.commit("addProposal", proposal);
        });
        break;
      case 'orders':
        documents = await requestApi({
          method: 'GET',
          url: '/api/getOrders?nocache=' + new Date().getTime(),
          params: param,
          form: {},
          headers: { 'Content-Type': 'application/json' }
        });
        documents.forEach(order => {
          order.date_commande = moment(order.date_commande * 1000).format("DD-MM-YYYY");
          if (order.date_livraison !== "") {
            order.date_livraison = moment(order.date_livraison * 1000).format("DD-MM-YYYY");
          } else {
            order.date_livraison = false;
          }
          order.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: order.multicurrency_code }).format(order.total_ht);
          order.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: order.multicurrency_code }).format(order.total_ttc);
          vuexStorage.commit("addOrder", order);
        });
        break;
      case 'invoices':
        documents = await requestApi({
          method: 'GET',
          url: '/api/getInvoices?nocache=' + new Date().getTime(),
          params: param,
          form: {},
          headers: { 'Content-Type': 'application/json' }
        });
        documents.forEach(invoice => {
          invoice.date_creation = moment(invoice.date_creation * 1000).format("DD-MM-YYYY");
          invoice.date_lim_reglement = moment(invoice.date_lim_reglement * 1000).format("DD-MM-YYYY");
          const now = Date.now();
          invoice.date_lim_sup = now > (invoice.date_lim_reglement * 1000) ? 1 : 0;
          invoice.total_ht = new Intl.NumberFormat(0, { style: 'currency', currency: invoice.multicurrency_code }).format(invoice.total_ht);
          invoice.total_ttc = new Intl.NumberFormat(0, { style: 'currency', currency: invoice.multicurrency_code }).format(invoice.total_ttc);
          vuexStorage.commit("addInvoice", invoice);
        });
        break;
      default:
        toasterError(`Type de document inconnu`, 'Chargement des documents');
    }
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

//Fonction de chargement du nom et prenom
async function loadingInfo() {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/loadingInfo',
      form: {},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    vuexStorage.commit('updateInfo', response);
  } catch (error) {
    try {
      const disconnectResponse = await requestApi({
        method: 'POST',
        url: '/api/disconnect',
        form: {},
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.$router.push(disconnectResponse.route);
    } catch {
      this.$router.push('/');
    }
  }
}

//Fonction de changement d'entreprise multisite
async function changeTiers(tiers, socname) {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/changeTiers',
      form: { socid: tiers.socid, socname: socname },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$router.push("/");
  } catch (error) {
    console.log(error);
  }
}

//Fonction de choix du template mail d'envoie de code d'accès
async function loadingTemplateMail(template, email, pwd, tokenReinit) {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/getInfoClient',
      form: { email: email },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });

    const response2 = await requestApi({
      method: 'POST',
      url: '/api/template',
      form: {
        template: template,
        email: email,
        pwd: pwd,
        tokenReinit: tokenReinit,
        prenom: response.firstname,
        nom: response.lastname,
        ref: response.ref_entreprise,
        nomEntreprise: response.nom_entreprise
      },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });

    this.form.contenuMail = response2.content;
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      this.$router.push('/');
    }
  }
}

//Fonction de chargement des templates mail
async function loadingTemplatesMail() {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/templates',
      form: {},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    var templateBase = { value: null, text: 'Template de base', active: 1 };
    this.templates.push(templateBase);
    for (var i = 0; i < response.length; i++) {
      var tmp = { value: response[i].value, text: response[i].text, active: response[i].active };
      this.templates.push(tmp);
    }
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      this.$router.push('/');
    }
  }
}

//Fonction de chargement des templates mail actif
async function loadingTemplatesMailActive() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/templatesActive',
      form: {},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    var templateBase = { value: null, text: 'Template de base' };
    this.templates.push(templateBase);
    for (var i = 0; i < response.length; i++) {
      var tmp = { value: response[i].value, text: response[i].text };
      this.templates.push(tmp);
    }
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      this.$router.push('/');
    }
  }
}

//Chargement de la vitesse du carrousel
async function loadSpeed() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/loadConfCarrousel',
      form: {},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    for (var i = 0; i < response.length; i++) {
      if (response[i].name == "CARROUSEL_TIMEOUT") {
        this.confCarrousel.vitesse = response[i].value;
      }
    }
  } catch (error) {
    if (error.response !== undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      this.$router.push('/');
    }
  }
}

//Fonction d'affichage du modal de modification des infos perso du client
function modifInfoPerso(target){
  this.$root.$emit('bv::show::modal', 'modalInfoPerso',target);
}

//Fonction réinitialisation du modal
function resetModal() {
  this.modalInfo.title = ''
  this.modalInfo.content = ''
}

//Fonction de chargement de produit
async function searchProducts(querystring){
  let search = querystring
  try {
		let products = await requestApi({method: 'GET', url: '/api/searchProduct?nocache=' + new Date().getTime(), params: {search: search}, form: {}, headers: {'Content-Type': 'application/json'}})
    let res = []
    products.forEach(async element => {
      let marque = ""
      if(element.array_options){
        if(element.array_options.option_marque){
          marque = element.array_options.option_marque
        }
      }
      let prixHT = Number.parseFloat(element.price).toFixed(2)
      let prixTTC = Number.parseFloat(element.price_ttc).toFixed(2)
      let tauxTVA = Number.parseFloat(element.tva_tx).toFixed(2)
      try {
        let documents = await requestApi({method: 'GET', url: '/api/getProductDocuments?nocache=' + new Date().getTime(), params: {id: element.id}, form: {}, headers: {'Content-Type': 'application/json'}})
        let images = []
        documents.forEach(document => {
          if((document.name.split('.').pop() == "jpeg") || (document.name.split('.').pop() == "png") || (document.name.split('.').pop() == "jpg")){
            images.push({
              name: document.name,
              path: document.fullname,
              encodedURI: encodeURI(document.fullname)
            })
          }
        })
        res.push({
          id: element.id,
          value: element.label,
          marque: marque,
          description: element.description,
          ref:element.ref,
          prixHT: prixHT,
          prixTTC: prixTTC,
          tauxTVA: tauxTVA,
          documents: documents,
          images: images,
          details: element 
        })
      } catch (error) {
        if(error.response != undefined){
          if(error.response.status == 401 || error.response.status == 400){
            console.log(error)
            this.$router.push('/');
          }else if(error.response.status == 404){
            res.push({
              id: element.id,
              value: element.label,
              marque: marque,
              description: element.description,
              ref:element.ref,
              prixHT: prixHT,
              prixTTC: prixTTC,
              tauxTVA: tauxTVA,
              documents: [],
              images: [],
              details: element
            })
          }
        }else{
          console.log(error)
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
    })
    return res
	} catch (error) {
		if(error.response != undefined){
			if(error.response.status == 401 || error.response.status == 400){
				this.$router.push('/');
			}
			toasterError(`Aucun produit n'a été trouvé`,`Recherche de produit`)
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
	}
}

//Fonction change password
async function setPass() {
  if (this.post.pwd == this.post.pwd2) {
    try {
      const response = await requestApi({
        method: 'POST',
        url: '/api/setPass',
        form: { pwd: this.post.pwd, token: this.$route.params.token },
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.$bvToast.toast(`Changement mot de passe réussi`, {
        title: 'Changement de mot de passe',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      });
      this.$router.push("../login");
    } catch (error) {
      if (error.response != undefined) {
        toasterError(`Changement de mot de passe impossible`, 'Changement de mot de passe');
      } else {
        toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
      }
    }
  } else {
    toasterError(`Les deux mots de passes ne correspondent pas`, 'Changement de mot de passe');
  }
}

// Upload des images du carrousel
async function uploadImg() {
  var myfile = document.getElementById("myfile").files;
  var formData = new FormData();
  var files = [];

  for (var i = 0; i < myfile.length; i++) {
    formData.append('myfile', myfile[i]);
    files.push({ name: myfile[i].name });
  }

  try {
    await requestApi({
      method: 'POST',
      url: '/api/uploadFilesCarrousel',
      form: formData,
      params: {},
      headers: { 'content-type': 'multipart/form-data' }
    });
    await requestApi({
      method: 'POST',
      url: '/api/addImg',
      form: files,
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    window.location.reload();
  } catch (error) {
    if (error.response != undefined && error.response.data.route != null) {
      this.$router.push(error.response.data.route);
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

// Fonction de vérification des droits de l'utilisateur
async function verifyRight() {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/verifyRight',
      form: { route: this.$route.name },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
  } catch (error) {
    if (error.response != undefined) {
      if (error.response.status == 403) {
        this.$router.push('error403');
      } else {
        try {
          await requestApi({
            method: 'POST',
            url: '/api/disconnect',
            form: {},
            params: {},
            headers: { 'Content-Type': 'application/json' }
          });
          window.location = "https:" + conf.server;
        } catch {
          window.location = "https:" + conf.server;
        }
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

// Fonction de vérification de token
async function verifyToken() {
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/verifyToken/' + this.$route.params.token,
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
  } catch {
    toasterError(`Temps pour changer de mot de passe écoulé`, 'Vérification');
    this.$router.push("../login");
  }
}

// Fonction de visualisation des document client
async function visualDoc(item, target) {
  try {
    let url;
    let title;
    if (item.last_main_doc != null) {
      url = '/api/visualDoc/' + item.last_main_doc;
      title = "Document " + item.ref + " : " + item.ref_client + " du " + item.date_creation;
    } else {
      url = '/api/visualDoc/contract/' + item.ref + "/" + item.ref + '.pdf';
      title = "Document " + item.ref + " : " + item.ref_customer + " du " + item.date_creation;
    }
    await requestApi({
      method: 'GET',
      url: url,
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.visualSrc = conf.server + url;
    this.modalVisual.title = title;
    this.$root.$emit('bv::show::modal', 'modalVisual', target);
  } catch {
    toasterError(`Visualisation du document impossible`, 'Visualisation du document');
  }
}

// Fonction de visualisation des document client (client)
async function visualDocClient(item, target) {
  try {
    let url;
    let title;
    if (item.last_main_doc != null) {
      var lastMainDoc = item.last_main_doc.split('/');
      url = '/api/visualDoc/' + item.last_main_doc;
      title = "Document " + item.ref + " : " + item.ref_client + " du " + item.date_creation;
      await requestApi({
        method: 'GET',
        url: url,
        params: {},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.visualSrc = conf.server + url;
      this.modalVisual.title = title;
      switch (lastMainDoc[0]) {
        case "facture":
          this.$root.$emit('bv::show::modal', 'modalVisualFactures', target);
          break;
        case "propale":
          this.$root.$emit('bv::show::modal', 'modalVisualDevis', target);
          break;
        case "commande":
          this.$root.$emit('bv::show::modal', 'modalVisualCommandes', target);
          break;
        default:
          break;
      }
      this.$root.$emit('bv::show::modal', 'modalVisual', target);
    } else {
      url = '/api/visualDoc/contract/' + item.ref + "/" + item.ref + '.pdf';
      title = "Document " + item.ref + " : " + item.ref_customer + " du " + item.date_creation;
      await requestApi({
        method: 'GET',
        url: url,
        params: {},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.visualSrc = conf.server + url;
      this.modalVisual.title = title;
      this.$root.$emit('bv::show::modal', 'modalVisualContrats', target);
    }
  } catch {
    toasterError(`Visualisation du document impossible`, 'Visualisation du document');
  }
}

// Fonction de visualisation des templates mail
async function visualiserTemplate(title, template, target) {
  try {
    const response = await requestApi({
      method: 'POST',
      url: '/api/templateVisual',
      form: { template: template },
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.modalVisualTemplate.title = title;
    this.modalVisualTemplate.content = response.content;
    this.$root.$emit('bv::show::modal', 'modalVisualTemplate', target);
  } catch (error) {
    if (error.response != undefined) {
      toasterError(`Impossible de charger la visualisation du template`, 'Visualisation impossible');
      if (error.response.data.route != null) {
        this.$router.push(error.response.data.route);
      }
    } else {
      toasterError(`Le service est momentanément indisponible`, 'Service indisponible');
    }
  }
}

// Fonction d'ajout de produit dans un devis fk_product, label, qty, tva_tx, product_type, subprice

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
  changeTiers,
  disconnect,
  loadingInfo,
  isConnect,
  verifyRight,
  info,
  resetModal,
  loadingTemplatesMailActive,
  loadingTemplatesMail,
  loadingTemplateMail,
  loadDocuments,
  visualDoc,
  visualDocClient,
  commentDoc,
  getInfoClient,
  getInfoSocClient,
  changePassword,
  modifInfoPerso,
  changeInfoPerso,
  activeClassMenuProfil,
  visualiserTemplate,
  activerTemplate,
  loadCarrousel,
  uploadImg,
  changeSpeed,
  loadSpeed,
  deleteImg,
  changePassOublie,
  verifyToken,
  setPass,
  createPropal,
  searchProducts,
  addProduct,
  chooseProduct,
  deleteProduct,
  deleteProducts,
  toasterError,
  toasterSuccess,
};
